import { AppThunk } from 'app/store';
import { activeElementActivateLink } from 'modules/activeElement/slice';
import { activeElementLinkIdSelector } from 'modules/activeElement/externalSelectors';
import { devicesDeviceRemove } from 'modules/devices/slice';
import { AP_ID, CLIENT_ID, MESH_AP_ID } from 'modules/devices/constants';
import { useEditorStore } from 'modules/editor/store';

import {
  LINK_ID,
  linksLinkApIdGetter,
  linksLinkByIdSelector,
  linksLinkRemove,
  linksLinksAddOrUpdate,
  MESH_LINK_ID,
} from './slice';

export const linksDeleteMeshPoint: () => AppThunk = () => (dispatch, getState) => {
  const state = getState();
  const link = linksLinkByIdSelector(state, LINK_ID);
  const apId = linksLinkApIdGetter(link);
  if (apId === MESH_AP_ID) {
    dispatch(
      linksLinksAddOrUpdate({
        [LINK_ID]: {
          apId: AP_ID,
          clientId: CLIENT_ID,
          id: LINK_ID,
        },
      })
    );
  }
  const activeLinkId = activeElementLinkIdSelector(state);
  if (activeLinkId === MESH_LINK_ID) {
    dispatch(activeElementActivateLink(LINK_ID));
  }
  dispatch(linksLinkRemove(MESH_LINK_ID));
  dispatch(devicesDeviceRemove(MESH_AP_ID));
  useEditorStore.getState().deleteDevice(MESH_AP_ID);
};
